import React, { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

const YouTubeAutoPlayGrid = () => {
  const videoRefs = useRef([]);
  const location = useLocation();


  if (location.pathname == '/vedikshha') {

    var videos = [
      "SGiF72ve-bs",
      "s5lCWR1KqHo",
      "FKilBVXOjrE",

      "N6TZHjudJHo",
      "KLajj3YNbh4",
      "ZRZwsps1arI",

      "RTTEXy9EqNg",
      "MVuGl4wc8ZE",
    ];
  } else {

    var videos = [
      "NsQZkhHKMJA",
      "eWZwFHOGzx4",
      "yYCeXGhsLFM",
      "eQ7F0Hjh5HQ",
      "mh92zZee3JY",
      "ezf5BMzMyTU",
      "1X50MTI5qPo",
      "SQdEGoU6uAs",

      "9suet_JEUPs",
      "eQ7F0Hjh5HQ",

      "F7upNocFOts",

      "_Jhi-3lhjFs",
    ];
  }

  useEffect(() => {
    const observers = [];

    videoRefs.current.forEach((el) => {
      if (!el) return;

      const iframe = el.querySelector("iframe");

      const observer = new IntersectionObserver(
        ([entry]) => {
          if (!iframe) return;

          if (entry.isIntersecting) {
            if (!iframe.src.includes("autoplay=1")) {
              iframe.src =
                iframe.src +
                "&autoplay=1&mute=1&controls=0&playsinline=1";
            }
          } else {
            iframe.src = iframe.src.replace("&autoplay=1", "");
          }
        },
        { threshold: 0.6 }
      );

      observer.observe(el);
      observers.push(observer);
    });

    return () => observers.forEach((o) => o.disconnect());
  }, []);

  return (
    <div className="min-h-screen max-w-7xl mx-auto bg-white p-4">
      <div className="text-center max-w-3xl mx-auto mb-12">
        <span className="inline-block px-4 py-2 bg-gradient-to-r from-emerald-100 to-green-100 text-emerald-700 rounded-full text-sm font-medium mb-4">
          {location.pathname != '/vedikshha' ? "Kaanshi Films" : 'Vedikshha'}

        </span>
        <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">
          {location.pathname != '/vedikshha' ? "KFE" : 'Vedikshha'}{' '}
          <span className="bg-gradient-to-r from-emerald-600 to-green-600 bg-clip-text text-transparent">
            Talk Show
          </span>
        </h2>

      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {videos.map((id, index) => (
          <div
            key={id}
            ref={(el) => (videoRefs.current[index] = el)}
            className="aspect-video bg-black overflow-hidden rounded-xl"
          >
            <iframe
              src={`https://www.youtube.com/embed/${id}?mute=1&controls=0&rel=0&modestbranding=1`}
              className="w-full h-full"
              allow="autoplay; encrypted-media"
              allowFullScreen
              loading="lazy"
              title={`video-${index}`}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default YouTubeAutoPlayGrid;
